import React from 'react';
import { Link } from 'react-router-dom';
import { calculaPrevision, formatMs } from '../utils/time';

class ResultadoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 10000);
  }

  // eslint-disable-next-line
  // UNSAFE_componentWillUpdate() {
  //   if (this.interval) {
  //     clearInterval(this.interval);
  //   }
  // }
  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { resultados, sectores, controles, competicion, controlId } = this.props;

    // Calcular tiempos netos y filtrar
    const resultadosConTiempoNeto = resultados
      .map((resultado) => {
        let tiempoInicioCorrector = 0;
        if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
          tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
        }

        const tiempoAbsoluto = resultado['control_' + controlId + '_tiempo'];
        const tiempoNeto = tiempoAbsoluto ? (tiempoAbsoluto - tiempoInicioCorrector) : null;

        return { ...resultado, tiempoNeto };
      })
      // Filtrar: solo los que tienen tiempo y NO están descalificados ni retirados
      .filter((resultado) =>
        resultado.tiempoNeto &&
        !resultado.descalificado &&
        !resultado.retirado
      );

    // Ordenar por tiempo neto
    const resultadosOrdenados = [...resultadosConTiempoNeto].sort((a, b) =>
      a.tiempoNeto - b.tiempoNeto
    );

    return (
      <div className="w-ful mt-2">
        <div className="mx-auto max-w-5xl px-0 md:px-40">
          <ul className="space-y-3">
            {resultadosOrdenados.map((resultado, index) => {
              const prevision = calculaPrevision(competicion, controles, sectores, resultado);
              const posicion = index + 1;

              // Diferencia con líder
              const diferenciaConLider = (() => {
                if (index === 0) return '-';

                const redondearComoFormatMs = (ms) => {
                  let s = Math.floor(ms / 1000);
                  const milisegundos = ms % 1000;
                  if (milisegundos > 0) s++;
                  return s;
                };

                const segundosLider = redondearComoFormatMs(resultadosOrdenados[0].tiempoNeto);
                const segundosActual = redondearComoFormatMs(resultado.tiempoNeto);
                const difSegundos = segundosActual - segundosLider;

                if (difSegundos === 0) return '-';

                const h = Math.floor(difSegundos / 3600);
                const m = Math.floor((difSegundos % 3600) / 60);
                const s = difSegundos % 60;

                return `+ ${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
              })();

              return (
                <li key={resultado.dorsal} className="list-none">
                  <Link
                    to={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
                    className="block py-3 px-4 md:px-6 hover:bg-slate-900/70 transition"
                  >
                    <div className="flex items-center gap-3">
                      {/* Puesto */}
                      <div className="grid place-items-center h-10 w-10 rounded-lg text-sm font-semibold bg-slate-800 text-slate-200 border border-slate-700">
                        {posicion}
                      </div>

                      {/* Nombre + info */}
                      <div className="min-w-0 flex-1">
                        {resultado.preload ? (
                          <div className="h-4 w-48 rounded bg-slate-800 animate-pulse" />
                        ) : (
                          <div className="truncate text-white font-medium font-montserrat">
                            {resultado.nombre} {resultado.apellidos}
                          </div>
                        )}

                        {resultado.preload ? (
                          <div className="mt-2 h-3 w-64 rounded bg-slate-800 animate-pulse" />
                        ) : (
                          <div className="mt-1 text-sm text-slate-400 font-montserrat">
                            <div>
                              Dorsal <strong className="text-slate-200">{resultado.dorsal}</strong>
                              {resultado.categoriaNombre ? `, ${resultado.categoriaNombre}` : ''}
                              {resultado.clubNombre ? `, ${resultado.clubNombre}` : ''}
                            </div>

                            {(!competicion.carrera_finalizada &&
                              prevision.tiempoTotal !== null &&
                              prevision.porcentaje < 100) && (
                                <div className="mt-1">
                                  <div>
                                    Prev. {prevision.control ? prevision.control.nombre : 'META'}:{' '}
                                    <strong className="text-red-400 font-mono text-xs">{formatMs(prevision.tiempoTotal)} | {formatMs(competicion.hora_inicio + prevision.tiempoTotal)} h</strong>
                                  </div>
                                </div>
                              )}
                          </div>
                        )}
                      </div>

                      {/* Tiempo */}
                      <div className="text-right">
                        <div className="text-white font-mono text-sm">
                          {formatMs(resultado.tiempoNeto)}
                          <div className="mt-1 text-xs text-slate-400">
                            {diferenciaConLider}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Progreso */}
                    {!competicion.carrera_finalizada && prevision.porcentaje !== null && (
                      <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-slate-800">
                        <div
                          className="h-full bg-red-500"
                          style={{ width: `${prevision.porcentaje}%` }}
                        />
                      </div>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default ResultadoList;

